import { render, staticRenderFns } from "./BlacklistAff.vue?vue&type=template&id=3c2821f2"
import script from "./BlacklistAff.vue?vue&type=script&lang=js"
export * from "./BlacklistAff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports